import { SvgIcon, SvgIconProps } from '@mui/material'

export function JoyStickIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833374 11C0.833374 10.7239 1.05723 10.5 1.33337 10.5H14.6667C14.9429 10.5 15.1667 10.7239 15.1667 11V14.3333C15.1667 14.6095 14.9429 14.8333 14.6667 14.8333H1.33337C1.05723 14.8333 0.833374 14.6095 0.833374 14.3333V11ZM1.83337 11.5V13.8333H14.1667V11.5H1.83337Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16675 8.66669C8.16675 8.39054 8.39061 8.16669 8.66675 8.16669H12.6667C12.9429 8.16669 13.1667 8.39054 13.1667 8.66669V11C13.1667 11.2762 12.9429 11.5 12.6667 11.5H8.66675C8.39061 11.5 8.16675 11.2762 8.16675 11V8.66669ZM9.16675 9.16669V10.5H12.1667V9.16669H9.16675Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00004 1.83334C5.35571 1.83334 4.83337 2.35568 4.83337 3.00001C4.83337 3.64434 5.35571 4.16668 6.00004 4.16668C6.64437 4.16668 7.16671 3.64434 7.16671 3.00001C7.16671 2.35568 6.64437 1.83334 6.00004 1.83334ZM3.83337 3.00001C3.83337 1.80339 4.80342 0.833344 6.00004 0.833344C7.19666 0.833344 8.16671 1.80339 8.16671 3.00001C8.16671 4.19663 7.19666 5.16668 6.00004 5.16668C4.80342 5.16668 3.83337 4.19663 3.83337 3.00001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5062 4.1975C5.76532 4.29296 5.89798 4.58041 5.80252 4.83952L3.46919 11.1729C3.37372 11.432 3.08628 11.5646 2.82716 11.4692C2.56804 11.3737 2.43538 11.0863 2.53084 10.8272L4.86418 4.49382C4.95964 4.2347 5.24708 4.10203 5.5062 4.1975Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default JoyStickIcon